import { render, staticRenderFns } from "./ShowPromotionEvaluation.vue?vue&type=template&id=b9c394c2&"
import script from "./ShowPromotionEvaluation.vue?vue&type=script&lang=js&"
export * from "./ShowPromotionEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports